const APEX = 'communiosocial.com';

/** Community site origin. Empty slug must not become the apex host. */
export function tenantSiteURL(slug: string): string {
  const s = slug.trim().toLowerCase();
  if (!s || s === APEX || s === `www.${APEX}` || s.includes('.')) {
    return '';
  }
  return `https://${s}.${APEX}`;
}

export function saasStartPath(slug: string): string {
  const s = slug.trim().toLowerCase();
  return s ? `/saas/start/?slug=${encodeURIComponent(s)}` : '/saas/start/';
}

/** Slug origin after HTTPS is live (/setup/ polls until hostReady, then redirects here). */
export function communityOpenURL(slug: string): string {
  const origin = tenantSiteURL(slug);
  return origin ? `${origin}/` : communitySetupPath(slug);
}

/** Tenant bookmarkable sign-in page. Empty slug must not become the apex host. */
export function communityLoginURL(slug: string): string {
  const origin = tenantSiteURL(slug);
  return origin ? `${origin}/login/` : '';
}

/** Apex holding page while slug HTTPS cert is still issuing. */
export function communitySetupPath(slug: string): string {
  const s = slug.trim().toLowerCase();
  return s ? `/setup/?slug=${encodeURIComponent(s)}` : '/setup/';
}
